import { render, staticRenderFns } from "./scene_4.vue?vue&type=template&id=5c17aea8&"
import script from "./scene_4.vue?vue&type=script&lang=ts&"
export * from "./scene_4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports